export const CONTENT_TYPES = {
  ABOUT_US: 'ABOUT_US',
  TERMS_OF_SERVICE: 'TERMS_OF_SERVICE',
  PRIVACY_POLICY: 'PRIVACY_POLICY'
}
